import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Button, ButtonToolbar, Modal, Col, Row, Card, CardBody, Container} from 'reactstrap';
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import * as TextManager from "../modules/languages/TextManager";
import NumberFormat from 'react-number-format';
import Select from './Select'
import Alert from "./Alert";
import * as http from "../modules/http";

const providers = [
    {value: "cellcom", label: "סלקום"},
    {value: "partner", label: "פרטנר"},
    {value: "012m", label: "012 מובייל"},
    {value: "pelephone", label: "פלאפון"},
    {value: "hotm", label: "הוט מובייל"},
    {value: "rami", label: "רמי לוי"},
    {value: "golan", label: "golan"},
];

class ModalClickOne extends PureComponent {
    static propTypes = {
        title: PropTypes.string,
        message: PropTypes.string,
        color: PropTypes.string.isRequired,
        colored: PropTypes.bool,
        header: PropTypes.bool
    };

    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            warning: '',
            errorText: '',
            provider: '',
            phone: ''
        };
    }

    componentDidMount() {
        //this.props.dispatch(fetchTasksDataIfNeeded(true));
    }

    send = () => {

        if (!this.state.provider || this.state.provider === '') {
            this.setState({warning: 'שדה ספק - חובה'});
            return;
        }
        if (!this.state.phone || this.state.phone === '') {
            this.setState({warning: 'שדה מספר טלפון - חובה'});
            return;
        }        

        http.postToServer(
            'clickone/send?provider=' + this.state.provider + '&phone=' + this.state.phone,
            {},
            (response) => {
                console.log(response.data);
                alert("נשלח בהצלחה");
            },
            (response) => {
                //this.setState({saving: false, error: true, errorText: response.data});
                alert("שגיאה בשליחה");
            }
        );

    };

    toggle = () => {
        this.setState({
            modal: !this.state.modal
        });
    };

    render() {

        let Icon;

        switch (this.props.color) {
            case 'primary':
                Icon = <span className='lnr lnr-pushpin modal__title-icon'/>;
                break;
            case 'success':
                Icon = <span className='lnr lnr-thumbs-up modal__title-icon'/>;
                break;
            case 'warning':
                Icon = <span className='lnr lnr-flag modal__title-icon'/>;
                break;
            case 'danger':
                Icon = <span className='lnr lnr-cross-circle modal__title-icon'/>;
                break;
            default:
                break;
        }

        return (
            <div onClick={this.toggle}>
                {this.props.children}
                <Modal isOpen={this.state.modal} toggle={this.toggle} style={{maxWidth: '800px', width: '800px'}}
                       className={`modal-dialog--${this.props.color} ${this.props.colored ? 'modal-dialog--colored' : ''} ${this.props.header ? 'modal-dialog--header' : ''}`}>
                    <div className='modal__header'>
                        <span className='lnr lnr-cross modal__close-btn' onClick={this.toggle}/>
                        {this.props.header ? '' : Icon}
                        <h4 className='bold-text  modal__title'>{this.props.title}</h4>
                    </div>
                    <div className='modal__body'>
                        <Container className='dashboard'>
                            {this.state.warning !== '' &&
                            <Row>
                                <Alert color='warning' className='alert--bordered' icon>
                                    <p><span
                                        className='bold-text'>{TextManager.getCurrentTextResource().Text.validation}</span> {this.state.warning}
                                    </p>
                                </Alert>
                            </Row>}
                            <Row>
                                <Col md={12} lg={12}>
                                    <form className="form">
                                        <div className="form__form-group">
                                            <div className="form__form-group">
                                                <div className="form__form-group-field" style={{flexDirection: "column"}}>
                                                    <Row style={{flexDirection: "row-reverse"}}>

                                                        <Col md={3} xs={12}>
                                                            <label
                                                                className='form__form-group-label'>ספק</label>
                                                            <div className='form__form-group-field'>
                                                                <Select
                                                                    name='select'
                                                                    value={this.state.provider}
                                                                    type={"select"}
                                                                    select
                                                                    options={providers}
                                                                    onChange={(value) => this.setState({ provider: value.value})}
                                                                >
                                                                </Select>
                                                            </div>
                                                        </Col>

                                                        <Col md={3} xs={12}>
                                                            <label className="form__form-group-label">
                                                                {TextManager.getCurrentTextResource().Text.phoneNumber}
                                                            </label>
                                                            <div className="form__form-group-field">
                                                                <NumberFormat name="customerName"
                                                                       style={{backgroundColor: '#F0F8FF'}}
                                                                       value={this.state.phone}
                                                                       type="text"
                                                                       dir={"auto"}
                                                                       onChange={(event) =>
                                                                           this.setState({phone: event.target.value})}
                                                                />
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                    <ButtonToolbar className='modal__footer'>
                        <Button onClick={this.toggle}>{TextManager.getCurrentTextResource().Text.cancel}</Button>{' '}
                        <Button outline={this.props.colored} color={this.props.color}
                                onClick={this.send}>
                            {TextManager.getCurrentTextResource().Sales.salesItem.send}</Button>
                    </ButtonToolbar>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        userData: state.userData,
        utilsData: state.utilsData
    };
};

export default withRouter(connect(mapStateToProps)(ModalClickOne))